import screenData from './data/screenData';

export default (screenSize) => {
    const { clientWidth, clientHeight } = document.documentElement;
    const { width, height } = screenData[screenSize];
    const offsetTop = (clientHeight - height) / 2;
    const offsetLeft = (clientWidth - width) / 2;
    return {
        // offsetTop: offsetTop > 0 ? offsetTop : 0,
        // offsetLeft: offsetLeft > 0 ? offsetLeft : 0,
        offsetTop,
        offsetLeft,
    };
};
